<template>
  <div class="menu-out-of-stock-list">
    <div class="animated fadeIn">
      <div v-if="isSearchBoxDisplay" class="c-background" @click="isSearchBoxDisplay = false"></div>
      <!-- Start of header session -->
      <b-row>
        <b-col>
            <div class="text-capitalize my-4">
              <strong>
                <h4>
                  <router-link :to="{ name: 'outlets_list'}" class="float-left mr-1 main-link">{{ $t('oos.huts') }}</router-link>
                  <span class="float-left mr-1">></span>
                  <router-link :to="{ name: 'outlets_edit',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{ $t('oos.hut_profile') }}</router-link>
                  <span class="float-left mr-1">></span>
                  {{ $t('oos.manage_stock') }}
                </h4>
              </strong>
          </div>
        </b-col>
      </b-row>
      <!-- End of header session -->

      <b-row class="min-vh-100 bg-white mx-1 mb-4">
        <b-col lg="12" md="12" sm="12">
          <b-card
            class="c-card"
            header-tag="header"
            footer-tag="footer">

            <!-- Start of Seach session -->
            <b-row class="mb-5">
              <b-col lg="8" md="12" sm="12">
                <div>
                  <h3> {{ store.flatten[store.flatten.length - 1] }} - {{ store.name.en }} </h3>
                  <p>{{ store.address.en }}</p>
                </div>
              </b-col>

              <b-col lg="4" md="12" sm="12" class="c-search-section">
                <b-input-group>
                  <input
                    ref="searchInput"
                    v-model="search"
                    @focus="search.length > 2 ? isSearchBoxDisplay = true : '' "
                    @keyup.enter="searchData()"
                    type="text"
                    class="form-control"
                    :placeholder="$t('oos.seach_placeholder')">

                  <div class="input-group-append c-group-append" @click="searchData()">
                    <span v-show="search.length" class="clear-text-search" @click="search = ''">✕</span>
                    <b-input-group-append>
                      <b-btn>
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                  </div>
                </b-input-group>

                <div class="search-box">
                  <transition name="fade">
                    <div v-show="isSearchBoxDisplay" class="search-box-result">
                      <div class="loading-custom" :class="{ loading: loading }">
                        <div class="image-loading-custom"></div>
                      </div>
                      <div class="d-flex justify-content-center align-items-center text-black-50 position-absolute top-left w-100 h-100"
                          v-if="!hasSearchBoxItems">{{ $t('oos.empty_data') }}</div>
                      <b-list-group v-else>
                        <b-list-group-item >
                          <template v-for="(item, indexName) in searchBoxItems">
                            <div :key="indexName">
                              <span class="search-result-text-group" v-show="item.length">{{ indexName }}</span>
                              <b-list-group>
                                <b-list-group-item class="list-group-item-second" v-for="ele of item" :key="ele.id" @click="showDialogOOS(ele)">
                                  <span v-show="isSingleProductTypes(indexName)">{{ getSkuCode(ele.inventoryItem.skus) }} - </span>
                                  <span class="highlight-parent" v-html="$options.filters.searchHighlighting(ele.inventoryItem.title, search)"></span>
                                </b-list-group-item>
                              </b-list-group>
                            </div>
                          </template>
                        </b-list-group-item>
                      </b-list-group>
                    </div>
                  </transition>

                </div>
              </b-col>
            </b-row>
            <!-- Start of Seach session -->

            <!-- Start of Data table -->
            <div class="table-responsive">
              <div class="table-header-text">
                <h4>{{ $t('oos.items_oos') }}</h4>
              </div>
              <!-- Loading and empty data -->
              <div v-if="!dataTable.items.length" class="table-empty-data">
                <div v-if="tableLoading" class="content-loading">
                  <span>{{ $t('oos.table_loading_text') }}</span>
                </div>
                <div v-else class="content-empty">
                  <div>{{$t('oos.no_data_header')}}.</div>
                  <div>{{$t('oos.no_data_content')}}.</div>
                </div>
              </div>
              <!-- List OOS -->
              <table v-else class="table table-hover table-md">
                <thead class="table-header">
                  <tr class="table-header-tr">
                    <th scope="col" class="w-20 w-2" >{{ $t('oos.category') }} <!-- <i class="fa fa-arrow-down ml-3"></i> --></th>
                    <th scope="col">{{ $t('oos.name') }}</th>
                    <th scope="col">{{ $t('oos.pos_code') }}</th>
                    <th scope="col">{{ $t('oos.status') }}</th>
                  </tr>
                </thead>

                <tbody>
                  <template v-if="dataTable.items.length">
                      <tr v-for="item in dataTable.items" :key="item.id" class="c-table-body-row" @click="showDialogOOSFromTable(item)">
                        <td class="text-capitalize">{{ item.type }}</td>
                        <td>{{ item.inventoryItem.title }}</td>
                        <td> <span v-show="isSingleProductTypes(item.type)">{{ getSkuCode(item.inventoryItem.skus) }}</span></td>
                        <td><span class="remove-icon">✕</span>{{ $t('oos.oos') }}</td>
                      </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <!-- End of Data table -->

          </b-card>
        </b-col>
      </b-row>

      <b-modal
        :modal-class="'c-modal-class ' + (hasShowRelatedDeals() ? '' : 'hide-body')"
        centered
        no-fade
        v-model="isShowModal">
        <template #modal-title>
          <h3 class="font-weight-600">{{ $t('oos.manage_item_status') }}</h3>
          <span class="text-black-50 text-uppercase">{{ selectedItem.type }}</span>
          <h4 class="row">
            <div class="font-weight-600 col-8">
              <span v-show="isSingleProductTypes(selectedItem.type)">{{ getSkuCode(selectedItem.inventoryItem.skus) }} - </span> {{ selectedItem.inventoryItem.title }}
            </div>
            <div class="col-4">
              <c-switch type="text" variant="success" on="Available" off="Out of Stock" :pill="true" class="float-right custom-label" :checked="selectedItem.available" @change="isDisabledButton = !isDisabledButton" />
            </div>
          </h4>
          <div class="related-deals-loading d-flex align-items-center" v-if="relatedDealsLoading">
            <h5 class="font-weight-600 mb-0">{{ $t('oos.loading_related_deals') }}&nbsp;&nbsp;&nbsp;</h5>
            <b-spinner variant="dark" small></b-spinner>
          </div>
        </template>
        <template v-if="hasShowRelatedDeals()">
          <div class="d-flex align-items-center justify-content-between pr-48">
            <h5 class="font-weight-600">
              {{ $t('oos.related_deals') }}&nbsp;
              <a href="javascript:void(0);" id="tooltip-note-hover">
                <i class="fa fa-exclamation-circle"></i>
              </a>
              <b-tooltip 
                target="tooltip-note-hover" 
                variant="secondary" 
                placement="right">
                  {{ $t('oos.this_item_will_be_automatically_removed_from_related_deals_if_marked_out_of_stock') }}
              </b-tooltip>
            </h5>
            <h5 class="font-weight-600">{{ $t('oos.deal_status') }}</h5>
          </div>
          <div class="related-deals">
            <div class="deal-item" v-for="deal in relatedDeals" :key="deal.id">
              <span>{{ getSkuCode(deal.inventoryItem.skus) }} - {{ deal.inventoryItem.title }}</span>
              <div class="flex-grow-1">
                <c-switch 
                  type="text" 
                  on="✓" 
                  variant="success"
                  :pill="true" 
                  class="float-right custom-label" 
                  v-model="deal.available" 
                  :checked="deal.available" 
                  @change="updateOOSDealList()" 
                />
              </div>
            </div>
          </div>
        </template>
        <template #modal-footer>
          <div class="d-flex align-items-center"
            :class="{ 'justify-content-between' : hasShowRelatedDeals(),  'justify-content-end': !hasShowRelatedDeals() }">
            <span v-if="hasShowRelatedDeals()">
              {{ $t('oos.changing_the_status_of') }} 
              <b> {{ isDisabledButton ? 0 : 1 }} {{ $t('oos.item') }}</b> 
              <span>{{ $t('oos.and') }}</span> 
              <b>{{oosDeals.length}} {{ $t('oos.deal') }}(s).</b>
            </span>
            <div>
              <b-button class="btn-cancel font-weight-600" variant="outline-danger" @click="isShowModal=false">{{ $t('oos.cancel') }}</b-button>
              <b-button class="px-4 ml-4" variant="success" :disabled="isDisableDialogSaveButton()" @click.once="changeStatusOOS(selectedItem)">
                <span class="c-white font-weight-600" v-if="!btnLoading">{{ $t('oos.save') }}</span>
                <div v-else class="d-inline-block px-2">
                  <b-spinner variant="white" small></b-spinner>
                </div>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>

import cSwitch from '../../../components/Switch';
  let vm = null;

  const itemInitial = {
    id: 0,
    inventoryItem: {
      metadata: { type: '', subtype: ''},
      skus:[]
    },
    available: true
  };
  const storeInitial = {
    id: 0,
    code: '',
    name: { en: '' },
    address: { en: '' },
    flatten: []
  }
  const MIN_TEXT_LENGTH_SEARCH = 3;
  const MAX_TEXT_LENGTH_SEARCH = 255;
  const MAX_DEBOUNCE_MILISECONDS = 1000;
  const MAX_DEBOUNCE_MILISECONDS_AFTER_FIVE_LETTERS = 500;
  const ADD_OOS_TYPE = 1;
  const REMOVE_OOS_TYPE = 2;

  export default {
    name: 'MenuOutOfStockList',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      cSwitch
    },

    data: function () {
      return {
        typeOfSubmit: ADD_OOS_TYPE, 
        search: '',
        availableProductTypes: '',
        singleProductTypes: [],
        unavailableProductSkus: [],
        translationLanguage: 'en-gb',
        isSearchBoxDisplay: false,
        searchBoxItems: {},
        relatedDeals: [],
        oosDeals: [],
        autoSearchAfterLetters: 5,
        loading: false,
        btnLoading: false,
        tableLoading: true,
        relatedDealsLoading: false,
        timer: null,
        isShowModal: false,
        isDisabledButton: true,
        selectedItem: itemInitial || {},
        store: storeInitial || {},
        clickOnOosTable: false,
        dataTable: {
          items: [],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          totalPage: 1,
          total: 3,
          perPage: 10
        },
        headers: {
          tenant: '',
          campaignName: '',
          exportPath: '',
          storeCode: '',
          locale: 'en-gb'
        }
      }
    },

    created: function () {
      vm = this;
      vm.debouncedInput = _.debounce(this.searchData, MAX_DEBOUNCE_MILISECONDS);

      if (localStorage.getItem('clientID') !== vm.client_uuid.uk1 && localStorage.getItem('clientID') !== vm.client_uuid.uk2) {
        vm.$router.push({ name: 'gms' })
        return;
      }

      vm.loading = false;

      // initial config
      const config = vm.$session.get('config');
      const manualConfig = vm._.get(config, 'manual_config', {}) || {};
      const { export_path, tenant_code, campaign_name, available_product_types, locale, unavailable_product_skus = '' } = manualConfig;
      vm.availableProductTypes = available_product_types;
      vm.unavailableProductSkus = (unavailable_product_skus || '').split(',');
      vm.headers.tenant = tenant_code;
      vm.headers.campaignName = campaign_name;
      vm.headers.exportPath = export_path;
      vm.headers.locale = locale;

      const { dip: dipType, side: sideType, dessert: dessertType, drink: drinkType } = vm.productType.uk;
      vm.singleProductTypes = [dipType, sideType, dessertType, drinkType];

       if (vm.$route.params.uuid) {
        vm.axios.outlet.getOutletDetail(vm.$route.params.uuid,
          function (response) {
            const { id, code, name, address } = vm._.get(response, 'data.data.item', []);
            const flatten = code.includes('/') ? code.split('/') : [code];
            vm.store =  { id, code, name, address, flatten };

            // add storeCode to header
            vm.headers.storeCode = flatten[flatten.length - 1];

            // call list of oos
            const params = {
              productTypes: vm.availableProductTypes,
            }
            vm.getMenuOutOfStockList(params);
          });
      }

      // add default transtaltion language to correspond with client
      vm.translationLanguage = vm.client_language[localStorage.getItem('clientID')]
    },
    computed: {
      hasSearchBoxItems: function () {
        return Object.keys(vm.searchBoxItems).length !== 0
      },
      getSkuCode: function() {
        return (skus = []) => skus.length ? skus[0].code : '';
      }
    },

    methods: {
      async getMenuOutOfStockSearch(params = '') {
        await vm.axios.menuOutOfStock.getMenuOutOfStockSearch(params, vm.headers,
          response => {
            vm.loading = false;
            let items = vm._.get(response, 'data.data.items', []).filter(item => vm.filterUnavailableProductSkus(item));
            if (!items.length) {
              vm.searchBoxItems = {};
              return;
            }

            // group by name, slice items, group by type
            vm.searchBoxItems = Object.values(items.reduce((acc, item) => vm.groupByName(acc, item), {}))
              .slice(0, 8)
              .reduce((acc, item) => vm.groupByType(acc, item), {});
          },
          error => {
            vm.loading = false;
            if (error.statusCode === 400) {
                error.errors.forEach(element => {
                  vm.$toastr.error(element.errorMessage, vm.$t('message.error'), {});
              });
            }
          })
      },

      async getMenuOutOfStockList(args = {}) {
        const params = vm.objectToParams(args);
        vm.tableLoading = true;
        await vm.axios.menuOutOfStock.getMenuOutOfStockList(params, vm.headers,
          response => {
            let oosList = vm._.get(response, 'data.data.items', []).filter(item => vm.filterUnavailableProductSkus(item));
            vm.dataTable.items = Object.values(oosList.reduce((acc, item) => vm.groupByName(acc, item), {}));
            vm.tableLoading = false;
          }
        );
      },

      getRelatedDealList(args = {}) {
        const params = vm.objectToParams(args);
        vm.relatedDealsLoading = true;
        vm.axios.menuOutOfStock.getRelatedDealList(params, vm.headers,
          response => {
            let relatedDealsData = vm._.get(response, 'data.data.items', []).filter(item => vm.filterUnavailableProductSkus(item));
            vm.relatedDeals = Object.values(relatedDealsData.reduce((acc, item) => vm.groupByName(acc, item), {}));
            vm.relatedDealsLoading = false;
          },
          __ => {
            vm.resetRelatedDeals();
          }
        );
      },

      filterUnavailableProductSkus (item) {
        if (item.inventoryItem.type !== vm.productType.uk.deal) {
          return true;
        }

        const sku = vm._.get(item, 'inventoryItem.skus', [])[0] || { id: 0, code: '0'};
        return !vm.unavailableProductSkus.includes(sku.code);
      },

      searchData(textSearch = '') {
        if (vm.search.length < MIN_TEXT_LENGTH_SEARCH || vm.search.length > MAX_TEXT_LENGTH_SEARCH) {
          vm.isSearchBoxDisplay = false;
          return;
        }

        let searchText = textSearch || vm.search;
        vm.isSearchBoxDisplay = true;
        const paramObject = {
          productTypes: vm.availableProductTypes,
          searchText
        }
        const params = vm.objectToParams(paramObject);
        vm.loading = true;
        vm.getMenuOutOfStockSearch(params);
      },

      resetRelatedDeals() {
        vm.relatedDeals = [];
        vm.oosDeals = [];
        vm.relatedDealsLoading = false;
      },

      showDialogOOS(item) {
        vm.selectedItem = {
          ...item,
          available: true
        }
        
        vm.resetRelatedDeals();
        if (vm.hasDeals(item.type)) {
          vm.getRelatedDealList({ inventoryItemIds: item.inventoryItemIds });
        }

        vm.clickOnOosTable = false;
        vm.isShowModal = true;
        vm.isDisabledButton = true;
        vm.typeOfSubmit = ADD_OOS_TYPE;
      },

      updateOOSDealList() {
        vm.oosDeals = vm.relatedDeals.filter(deal => !deal.available);
      },

      showDialogOOSFromTable(item) {
        vm.selectedItem = {
          ...item,
          available: false
        }
        vm.resetRelatedDeals();
        vm.clickOnOosTable = true;
        vm.isShowModal = true;
        vm.isDisabledButton = true;
        vm.typeOfSubmit = REMOVE_OOS_TYPE
      },

      addItemsToOos(item) {

        let oosPayload = [];
        let mergedOosData = [];
        if (vm.oosDeals.length) {
          oosPayload = [...vm.oosDeals].reduce((acc, cur)  => [...acc, ...cur.collections], []);
          mergedOosData = [...vm.oosDeals];
        }
        if (!vm.isDisabledButton) {
          oosPayload = [...oosPayload, ...item.collections];
          mergedOosData = [...mergedOosData, {...item} ];
        }

        mergedOosData = mergedOosData.map(item => {
          return {
            id: item.id || null,
            type: item.inventoryItem.type || '',
            available: false,
            inventoryItem: item.inventoryItem,
            inventoryItemId: item.inventoryItemId,
            collections: [...item.collections]
          }
        });

        vm.btnLoading = true;
        vm.axios.menuOutOfStock.addItemOutOfStock({ prices: oosPayload }, vm.headers,
          response => {

            vm.btnLoading = false;
            let createdData = vm._.get(response, 'data.data.items', []);
            createdData = createdData.map(createdItem => {
              const oosItem =  mergedOosData.find(item => item.inventoryItemId === createdItem.inventoryItemId);
              if (oosItem) {
                oosItem.collections = oosItem.collections.map(ele => {
                  const oosEle = createdData.find(item => item.inventoryItemId === ele.inventoryItemId);
                  return {
                    inventoryItemId: oosEle.inventoryItemId,
                    priceId: oosEle.id,
                    title: ele.title
                  }
                });
                return oosItem;
              };
            }).filter(Boolean);

            vm.dataTable.items = [...createdData, ...vm.dataTable.items];
            
            if (vm.oosDeals.length) {
              vm.resetRelatedDeals();
            }

            // remove item form dropdown seaching list
            if (!vm.isDisabledButton) {
              vm.searchBoxItems[item.type] = vm.searchBoxItems[item.type].filter(ele => ele.id !==  item.id);
            }
           
            // reset selected item and dismiss dialog and show alert
            vm.selectedItem = itemInitial;
            vm.isShowModal = false;
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {});
          },
          error => {
            vm.btnLoading = false;
            if (error.statusCode === 400) {
                error.errors.forEach(element => {
                vm.$toastr.error(element.errorMessage, vm.$t('message.error'), {});
              });
            }
          }
        );
      },

      async removeItemsFromOos(item) {
        const payload = {
          prices: item.collections
        }

        vm.btnLoading = true;
        await vm.axios.menuOutOfStock.removeItemFromOutOfStock(payload, vm.headers,
          success => {

            vm.btnLoading = false;
            // remove item form oos list
            vm.dataTable.items = vm.dataTable.items.filter(ele => ele.id !==  item.id);

            // reset selected item and dismiss dialog and show alert
            vm.selectedItem = itemInitial;
            vm.isShowModal = false;
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {});
          },
          error => {
            vm.btnLoading = false;
            if (error.statusCode === 400) {
                error.errors.forEach(element => {
                  vm.$toastr.error(element.errorMessage, vm.$t('message.error'), {});
              });
            }
          }
        )

      },

      changeStatusOOS(item) {
        switch (vm.typeOfSubmit) {
          case ADD_OOS_TYPE:
            vm.addItemsToOos(item);
            break;
          case REMOVE_OOS_TYPE:
            vm.removeItemsFromOos(item);
            break;
          default:
            return;
        }
      },

      // this function means will trigger after 5 letter, with number % 5 != 0 for advance case
      debounce_(fn, delay) {
        clearTimeout(vm.timer);
        vm.timer = setTimeout(function() {
          if (vm.search.length > vm.autoSearchAfterLetters && ((vm.search.length % vm.autoSearchAfterLetters) !== 0)) {
            fn();
          }
        }, delay);
      },

      getNameLowerCase(item) {
        return (item.inventoryItem.title || '' + '').toLowerCase().replaceAll(' ', '-');
      },

      getNameCombineRandom(item) {
        return vm.getNameLowerCase(item) + '|' + item.inventoryItem.groupName + '|' + item.id;
      },

      // when fetch list all data we need to group by title in order to unique
      groupByName(acc, item) {
        const { id: inventoryItemId, type, title }  = vm._.get(item, 'inventoryItem', {}) || {};
        const priceItem = {
            inventoryItemId,
            priceId: item.id,
            title,
            type
        }
        const { pizza: pizzaType, crust: crustType,  deal: dealType, } = vm.productType.uk;
        if ([pizzaType, crustType, dealType].includes(type)) {
          const nameOfPizza = vm.getNameLowerCase(item);
          if (!acc.hasOwnProperty(nameOfPizza)) {
            acc[nameOfPizza] = {
              ...item,
              type,
              collections: [],
              inventoryItemIds: [],
            }
          }
          acc[nameOfPizza].collections.push(priceItem);
          acc[nameOfPizza].inventoryItemIds.push(inventoryItemId);
          return acc;
        }

        // single product types
        const nameOfOthers = vm.getNameCombineRandom(item);
        acc[nameOfOthers] = {
          ...item,
          type,
          collections: [ priceItem ],
          inventoryItemIds: [inventoryItemId ],
        };

        return acc;
      },

      // we will group all follow product type to show up on UI.
      groupByType(acc, item) {
        const { type } = item;
        (acc[type] === undefined)
          ? acc[type] = [item]
          : acc[type].push(item);
        return acc;
      },

      isDisableDialogSaveButton() {
        return vm.isDisabledButton && !vm.oosDeals.length;
      },

      isSingleProductTypes(type) {
        const { deal } = vm.productType.uk;
        return [...vm.singleProductTypes, deal].includes(type);
      },

      isAddDialogOOS () {
        return vm.typeOfSubmit === ADD_OOS_TYPE;
      },

      hasDeals(type) {
        const { deal, pizza } = vm.productType.uk;
        return vm.availableProductTypes.includes(deal) && [...vm.singleProductTypes, pizza].includes(type);
      },

      hasShowRelatedDeals() {
        return this.isAddDialogOOS() && this.relatedDeals.length;
      }
    },

    filters: {
      searchHighlighting: function (words, query) {
        if (query === '') return words;
        const iQuery = new RegExp(query, "ig");
        return words.toString().replace(iQuery, function(matchedTxt, a, b) {
          return (`<span class="highlight-text-search">${matchedTxt}</span>`)
        });
      }
    },

    watch: {
      'search': function (val = '') {
        const length_ = +val.length;

        if (length_ >= vm.autoSearchAfterLetters && ((length_ % vm.autoSearchAfterLetters) === 0)) {
          // run after each 5 letters and length of letter must be greater than 5 letters
          vm.debounce_(function () {
            vm.searchData(val);
          }, MAX_DEBOUNCE_MILISECONDS_AFTER_FIVE_LETTERS);
        }
        // run after each 1s
        vm.debouncedInput();
      }
    }
  }
</script>


<style scoped>

  .table-empty-data {
    margin-bottom: 20px;
  }

  .content-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    background-color: #F5F6F7;
  }

  .content-loading span {
    font-family: Open Sans;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .content-empty {
    display: flex;
    flex-flow: column;
  }

  .content-empty div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
  }

  .content-empty div:first-child {
    background-color: #F5F6F7;
    font-family: Open Sans;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
  }

  .content-empty div:nth-child(2) {
    font-family: Open Sans;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .loading-custom {
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, .6);
    z-index: 999999999999;
    display: none;
  }

  .image-loading-custom {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('./../../../../static/img/loader-bike.gif') no-repeat;
    background-position: center;
    background-size: 5rem;
  }

  .loading {
    display: initial;
  }

  .fade-enter-active,
  .fade-leave-active {
    opacity: 0;
    transform: translateY(-5%);
  }

  /deep/ .c-modal-class .modal-dialog {
    max-width: 628px;
  }

  /deep/ .c-modal-class span {
    color: #111111;
    font-size: 14px;
    line-height: 18px;
  }

  /deep/ .c-modal-class .font-weight-600 {
    font-weight: 600;
  }

  /deep/ .c-modal-class .pr-48 {
    padding-right: 48px;
  }

  /deep/ .c-modal-class .c-white {
    color: #ffffff;
  }

  /deep/ .c-modal-class #tooltip-note-hover {
    color: #0A8020;
  }

  /deep/ .c-modal-class h3 {
    font-size: 24px;
    line-height: 32px;
    color: #231F20;
  }

  /deep/ .c-modal-class h4, /deep/ .c-modal-class h4 span {
    font-size: 18px;
    line-height: 25px;
    letter-spacing: -0.145454px;
    color: #231F20;
  }

  /deep/ .c-modal-class h5 {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.145454px;
    color: #231F20;
  }

  /deep/ .c-modal-class .modal-header .modal-title {
    width: 100%;
    padding-right: 18px;
  }

  /deep/ .c-modal-class .modal-header .modal-title .related-deals-loading {
    border-top: 1px solid #d1d4d7;
    margin-left: -16px;
    margin-right: -64px;
    padding: 1rem 1rem 0 1rem;
  }

  /deep/ .c-modal-class.hide-body .modal-body {
    display: none !important;
  }
  /deep/ .c-modal-class .modal-footer {
    display: block;
  }
  /deep/ .c-modal-class.hide-body .modal-footer {
    border-top: 0;
  }
  /deep/ .c-modal-class > .modal-dialog > .modal-content {
    border-radius: 5px;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .related-deals {
    width: 100%;
    max-height: 234px;
    overflow: hidden;
    overflow-y: auto;
    padding-right: 24px;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .related-deals .deal-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 60px 15px 0;
    border-bottom: 1px solid #C4C4C4;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .related-deals .deal-item:last-child {
    border-bottom: 0;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .modal-header .switch-text {
    width: 114px;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .switch-text {
    height: 24px;
  }

 /deep/ .c-modal-class > .modal-dialog > .modal-content .switch-text .switch-label {
    background: #C8102E;
    font-size: 14px;
    text-transform: none;
 }

 /deep/ .c-modal-class > .modal-dialog > .modal-content .deal-item .switch-success .switch-label {
    font-weight: 900;
    line-height: 2.5px;
 }

 /deep/ .c-modal-class > .modal-dialog > .modal-content .modal-header .switch-text .switch-label::before {
    width: 90px;
 }

 /deep/ .c-modal-class > .modal-dialog > .modal-content .modal-header .switch-text .switch-label::after {
    width: 80%;
    text-align: center;
 }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .modal-header .switch.switch-text .switch-input:checked ~ .switch-handle {
    left: 92px;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .deal-item .switch.switch-text .switch-handle {
    left: 6px;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .deal-item .switch.switch-text .switch-input:checked ~ .switch-handle {
    left: 30px;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .modal-header .switch.switch-text .switch-handle {
    height: 18px;
    width: 18px;
    margin: 1px;
  }

  /deep/ .c-modal-class > .modal-dialog > .modal-content .deal-item .switch.switch-text .switch-handle {
    height: 12px;
    width: 12px;
    top: 6px;
  }

  .c-table-body-row:hover {
    cursor: pointer;
    background: var(--danger) !important;
    color: var(--light);
  }

  .c-background {
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 99;
  }

  .c-datatable-pagination {
    color: rgba(0, 0, 0, 0.5);
  }

  .c-datatable-first-text {
    font-size: 14px;
    line-height: 16px;
    color: #453F3F;
  }
  .clear-text-search {
    position: absolute;
    right: 2rem;
    z-index: 1000;
    cursor: pointer;
    padding: .5rem 1rem;
  }

  .c-card {
    border: none;
  }

  .table-header {
    background: #F5F6F7;
  }

  .table-header .table-header-tr th {
    color: #333333 !important;
  }

  .btn-cancel {
    background: #FFFFFF;
    border: 1px solid #C4C4C4 !important;
    box-sizing: border-box;
    border-radius: 5px;
    color: #000;
  }

  .highlight-parent >>> span.highlight-text-search {
     font-weight: bold !important;
  }

  .card-header {
    background: #e4e5e6 !important;
    color: #151b1e !important;
  }

  .table-header-text {
    margin: 2rem 0;
    color: #333333;
  }

  .remove-icon {
    color: red;
    padding: .5rem
  }

  .search-box {
    position: relative;
    width: 100%;
  }

  .search-box-result {
    position: absolute;
    min-height: 35vh;
    width: 100%;
    border: 1px solid #d1d4d7;
    padding: 1rem;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .1);
    transition: .2s;
    z-index: 100;
  }

  .list-group-item {
    border: none;
  }

  .list-group-item-second:hover {
    cursor: pointer;
    background: #e4e5e6;
  }

  .search-result-text-group {
    color: #6b6c6d;
    text-transform: uppercase;
  }

  .close-box-result {
    position: absolute;
    top: 0;
    right: 0;
    padding: 1rem;
    z-index: 101;
    cursor: pointer;
  }

  .close-box-result > span {
    font-size: 20px;
  }

  .custom-label {
    margin-bottom: 0;
    margin-left: .5rem;
    background: #0A8020;
    border-radius: 32px;
  }

  .c-search-section {
    z-index: 100;
  }

</style>



// WEBPACK FOOTER //
// src/views/admin/menu-out-of-stock/List.vue